import { CollapsibleFilter } from "../../ui/filter/CollapsibleFilter";
import DateFilter from "../../ui/filter/DateFilter";
import { cn } from "@/lib/utils";
import { dueDateFilters, postedDateFilters } from "./FilterValues";
import SearchFilter from "../../ui/filter/SearchFilter";

const status = [
  { label: "Posted", keys: ["posted"] },
  {
    label: "Forecasted",
    keys: ["forecasted"],
  },
];
const agencies = [
  "U.S. Mission to El Salvador",
  "U.S. Mission to Luxembourg",
  "USAID-VIETNAM",
  "El Salvador USAID-San Salvador",
  "U.S. Mission to Saudi Arabia",
  "Air Force -- Research Lab",
  "FAA-COE-AJFE",
  "Headquarters",
  "U.S. Mission to Russia",
  "NSWC Dahlgren",
  "National Veterans Sports Programs",
  "U.S. Mission to Indonesia",
  "Serbia USAID-Belgrade",
  "Air Force Office of Scientific Research",
  "Bureau of International Security-Nonproliferation",
  "AmeriCorps",
  "U.S. Mission to Bangladesh",
  "U.S. Mission to Azerbaijan",
  "West Africa USAID-Ghana",
  "Thailand USAID-Bangkok",
  "U.S. Mission to Cameroon",
  "National Institute of Standards and Technology",
  "IV&V Test Agency",
  "U.S. Mission to Namibia",
  "Ukraine USAID-Kiev",
  "Armenia USAID-Yerevan",
  "Agency for International Development",
  "National Institute of Justice",
  "U.S. Mission to India",
  "Ecuador USAID-Quito",
  "Department of Commerce",
  "Food and Drug Administration",
  "Centers for Medicare & Medicaid Services",
  "U.S. Mission to Ethiopia",
  "FAA-COE-JAMS",
  "U.S. Mission to Singapore",
  "National Endowment for the Arts",
  "Centers for Disease Control - NCEZID",
  "Office of Local Defense Community Cooperation",
  "U.S. Mission to Bolivia ",
  "Bureau of Population Refugees and Migration",
  "USAF 347 Contracting Squadron",
  "Liberia USAID-Monrovia",
  "Honduras USAID-Tegucigalpa",
  "Forest Service",
  "Animal and Plant Health Inspection Service",
  "U.S. Mission to Equatorial Guinea",
  "Bureau Of Educational and Cultural Affairs",
  "South Africa USAID-Pretoria",
  "National Park Service",
  "Bureau of Justice Assistance",
  "Mali USAID -Bamako",
  "National Institute of Food and Agriculture",
  "Bureau of International Labor Affairs",
  "U.S. Mission to Cambodia",
  "U.S. Mission to Israel",
  "East Africa USAID-Kenya",
  "Defense Threat Reduction Agency",
  "National Aeronautics and Space Administration",
  "Jordan USAID-Amman",
  "Employment and Training Administration",
  "Region 4",
  "U.S. Mission to Suriname",
  "National Highway Traffic Safety Administration",
  "India USAID-New Delhi",
  "Indian Health Service",
  "U.S. Mission to North Macedonia",
  "Pakistan USAID-Islamabad",
  "U.S. Mission to Jerusalem",
  "U.S. Mission to Armenia",
  "Burundi USAID-Bujumbura",
  "U.S. Mission to Ukraine",
  "Department of Education",
  "Golden Field Office",
  "Foreign Agricultural Service",
  "Substance Abuse and Mental Health Services Adminis",
  "Benin USAID-Cotonou",
  "Assistance Coordination",
  "Sri Lanka USAID-Colombo",
  "U.S. Mission to Brazil",
  "U.S. Mission to Tunisia",
  "Agency for Health Care Research and Quality",
  "Administration for Children and Families - OFA",
  "U.S. Mission to Togo",
  "Centers for Disease Control - NCIRD",
  "Air Force Academy",
  "Office of Juvenile Justice Delinquency Prevention ",
  "U.S. Mission to Vietnam",
  "Centers for Disease Control-GHC",
  "U.S. Mission to Djibouti",
  "Centers for Disease Control - NCBDDD",
  "Bureau of Indian Affairs",
  "Indonesia USAID-Jakarta",
  "Centers for Disease Control - OPHPR",
  "U.S. Mission to Latvia",
  "National Energy Technology Laboratory",
  "U.S. Mission to Nigeria",
  "DOT - FAA Aviation Research Grants",
  "U.S. Mission to Albania",
  "DARPA - Biological Technologies Office",
  "Rural Utilities Service",
  "U.S. Mission to France",
  "Administration for Children & Families - ACYF/FYSB",
  "NCA Contracting",
  "Dominican Republic USAID-Santo Domingo",
  "Office of National Drug Control Policy ",
  "Administration for Children and Families - ACYF/CB",
  "Cambodia USAID-Phnom Penh",
  "Office of the Secretary",
  "U.S. Mission to New Zealand",
  "Haiti USAID-Port Au Prince",
  "National Endowment for the Humanities",
  "U.S. Mission to Paraguay",
  "Georgia USAID-Tbilisi",
  "Ethiopia USAID-Addis Ababa ",
  "U.S. Mission to Guatemala",
  "U.S. Mission to Canada",
  "Administration for Children and Families - ORR",
  "Paraguay USAID-Asuncion",
  "U.S. Mission to Jordan",
  "Department of Defense",
  "U.S. Mission to Japan",
  "U.S. Mission to Burkina Faso",
  "Burma USAID - Rangoon",
  "Economic Development Administration",
  "U.S. Mission to Jamaica",
  "U.S. Mission to the Czech Republic",
  "DOT-Federal Motor Carrier Safety Administration",
  "U.S. Mission to Spain",
  "U.S. Mission to China",
  "Rwanda USAID-Kigali ",
  "Department of the Interior",
  "U.S. Mission to Bulgaria",
  "Guinea USAID-Conakry",
  "South Sudan (USAID)-Juba",
  "Bosnia USAID-Herzegovina",
  "Environmental Protection Agency",
  "Veterans Legacy Grants Program",
  "Advanced Research Projects Agency Energy ",
  "U.S. Mission to Nicaragua",
  "U.S. Mission to Kenya",
  "NNSA",
  "U.S. Mission to the Philippines",
  "Administration for Children and Families - OFVPS",
  "U.S. Mission to Cape Verde",
  "U.S. Mission to Argentina",
  "Tajikistan USAID-Dushanbe",
  "U.S. Mission to Ghana",
  "U.S. Mission to the United Nations",
  "Centers for Disease Control - NCHHSTP",
  "Institute of Museum and Library Services",
  "Centers for Disease Control and Prevention - ERA",
  "U.S. Mission to Kazakhstan",
  "Interior Business Ceter",
  "Agricultural Marketing Service",
  "U.S. Mission to Sudan",
  "U.S. Mission to Kyrgyzstan",
  "Azerbaijan USAID-Baku",
  "U.S. Mission to Tajikistan",
  "Democratic Republic of the Congo USAID-Kinshasa",
  "Mozambique USAID-Maputo",
  "U.S. Mission to Uganda",
  "Washington Headquarters Services",
  "NASA Headquarters",
  "Office of Procurement Operations - Grants Division",
  "U.S. Mission to the European Union",
  "Iraq USAID-Baghdad",
  "DARPA - Information Innovation Office",
  "Middle East Regional Platform USAID-MERP",
  "NAVAIR",
  "Naval Information Warfare Center Pacific",
  "U.S. Mission to Venezuela",
  "Macedonia USAID-Skopje",
  "Peru USAID-Lima",
  "Assistant Secretary for Preparedness and Response",
  "National Geospatial-Intelligence Agency ",
  "U.S. Mission to Lebanon",
  "Dept. of the Army -- USAMRAA",
  "U.S. Mission to Gabon",
  "U.S. Mission to the Dominican Republic",
  "Veterans Employment and Training Service",
  "Zimbabwe USAID-Harare",
  "Fort Worth District",
  "Mexico USAID-Mexico City",
  "Bureau of Democracy Human Rights and Labor",
  "U.S. Mission to Uzbekistan",
  "DARPA - Tactical Technology Office",
  "U.S. Mission to Slovakia ",
  "U.S. Dept. of Treasury RESTORE Act Program",
  "Administration for Children and Families - OCS",
  "Kenya USAID-Nairobi",
  "Engineer Research and Development Center",
  "Office of Science",
  "Natural Resources Conservation Service",
  "U.S. Mission to Serbia",
  "Construction of State Home Facilities",
  "U.S. Mission to Zimbabwe",
  "Egypt USAID-Cairo",
  "Nepal USAID-Kathmandu",
  "U.S. Mission to the United Kingdom",
  "U.S. Mission to Sweden",
  "ACC-APG-Aberdeen Division A",
  "Administration for Children and Families - OHS",
  "Office of Global Womens Issues",
  "U.S. Mission to Zambia",
  "U.S. Mission to the Netherlands",
  "Department of Homeland Security - FEMA",
  "Homeless Providers Grant and Per Diem Program",
  "Health Resources and Services Administration",
  "U.S. Mission to Egypt",
  "Maritime Administration",
  "DARPA - Defense Sciences Office",
  "Naval Surface Warfare Center - Carderock",
  "Office of the Assistant Secretary for Health",
  "Zambia USAID-Lusaka",
  "Dept of the Army -- Materiel Command",
  "Tanzania USAID-Dar es Salaam",
  "DOC NOAA - ERA Production",
  "Office to Monitor-Combat Trafficking in Persons",
  "U.S. Mission to South Africa",
  "Ghana USAID-Accra",
  "U.S. Mission to Lesotho",
  "Naval Research Laboratory",
  "U.S. Mission to Myanmar",
  "Afghanistan USAID-Kabul",
  "Supportive Services for Veteran Families",
  "U.S. Mission to Qatar",
  "U.S. Mission to the Democratic Republic of Congo",
  "Advanced Research Projects Agency for Health",
  "Nuclear Regulatory Commission",
  "United States Coast Guard ",
  "Nigeria USAID-Abuja",
  "Kosovo USAID-Pristina",
  "Idaho Field Office",
  "Guatemala USAID-Guatemala City",
  "Fish and Wildlife Service",
  "National Archives and Records Administration",
  "Senegal USAID-Dakar",
  "U.S. Mission to Norway",
  "Rural Housing Service",
  "Bureau of Land Management",
  "Munitions Directorate",
  "Department of Housing and Urban Development",
  "Administration for Children and Families - ANA",
  "National Institute of Corrections",
  "U.S. Mission to Mauritius",
  "National Telecommunications and Information Admini",
  "West Bank, Gaza USAID-West Bank",
  "Administration for Children and Families-IOAS-OTIP",
  "DOT Federal Highway Administration ",
  "Uganda USAID-Kampala",
  "U.S. Mission to Belize",
  "Geological Survey",
  "Germany USAID - Frankfurt",
  "Food and Nutrition Service",
  "NSWC - CRANE",
  "Colombia USAID-Bogota",
  "National Institutes of Health",
  "Bangladesh USAID-Dhaka",
  "Centers for Disease Control - NCCDPHP",
  "Bureau of International Narcotics-Law Enforcement",
  "NASA Johnson Space Center",
  "Morocco USAID-Rabat",
  "Administration for Children and Families",
  "Madagascar USAID-Antananarivo",
  "AFRL Kirtland AFB",
  "U.S. Mission to Rwanda",
  "Womens Bureau",
  "U.S. Mission to Mozambique",
  "Centers for Disease Control - NCIPC",
  "U.S. Mission to Australia",
  "Malawi USAID-Lilongwe",
  "Office of Naval Research",
  "U.S. Mission to Germany",
  "U.S. Mission to Eswatini",
  "Denali Commission",
  "Bureau of European and Eurasian Affairs",
  "Administration for Children and Families - OPRE",
  "U.S. Mission to Honduras",
  "Millennium Challenge Corporation",
  "Naval Supply Systems Command",
  "Rural Business-Cooperative Service ",
  "U.S. Mission to Malta",
  "Bureau of Reclamation",
  "U.S. Mission to Italy",
  "Philippines USAID-Manila",
  "Office of the National Coordinator",
  "U.S. Mission to Georgia",
  "DARPA - Microsystems Technology Office ",
  "Office on Violence Against Women",
  "U.S. Mission to Morocco",
  "U.S. Mission to Barbados",
  "Administration for Community Living",
  "DOT/Federal Transit Administration",
  "DOT - Federal Railroad Administration",
  "USAID - Barbados and Eastern Caribbean",
  "69A345 Office of the Under Secretary for Policy",
  "ACC APG - Natick",
  "National Science Foundation",
  "Yemen USAID-Sanaa",
];

const opportunityCategory = [
  "Continuation",
  "Discretionary",
  "Earmark",
  "Mandatory",
  "Other",
];

const applicantTypes = [
  "Nonprofits that do not have a 501(c)(3) status with the IRS, other than institutions of higher education",
  'Unrestricted (i.e., open to any type of entity above), subject to any clarification in text field entitled "Additional Information on Eligibility"',
  "Native American tribal organizations (other than Federally recognized tribal governments)",
  "Nonprofits having a 501(c)(3) status with the IRS, other than institutions of higher education",
  "Independent school districts",
  "Special district governments",
  "Public and State controlled institutions of higher education",
  "For profit organizations other than small businesses",
  "Individuals",
  "Public housing authorities/Indian housing authorities",
  "Native American tribal governments (Federally recognized)",
  "County governments",
  "Private institutions of higher education",
  "Small businesses",
  "City or township governments",
  "State governments",
  'Others (see text field entitled "Additional Information on Eligibility" for clarification)',
];

const fundingCategories = [
  "Regional Development",
  "Health",
  "Science and Technology and other Research and Development",
  "Education",
  "Affordable Care Act",
  "Disaster Prevention and Relief",
  "Food and Nutrition",
  "Energy",
  "Recovery Act",
  "Arts",
  "Information and Statistics",
  "Infrastructure Investment and Jobs Act (IIJA)",
  "Opportunity Zone Benefits",
  "Business and Commerce",
  "Consumer Protection",
  "Environment",
  "Transportation",
  "Humanities",
  "Agriculture",
  'Other (see text field entitled "Explanation of Other Category of Funding Activity" for clarification)',
  "Income Security and Social Services",
  "Natural Resources",
  "Housing",
  "Law, Justice and Legal Services",
  "Community Development",
  "Employment, Labor and Training",
];

const fundingInstruments = [
  "Cooperative Agreement",
  "Grant",
  "Procurement Contract",
  "Other",
];

export default function GrantFilters({ className, ...props }) {
  return (
    <div className={cn("flex flex-col space-y-4", className)} {...props}>
      <CollapsibleFilter title="Status" urlName="oppStatus" items={status} />
      <DateFilter
        title={"Due Date"}
        filters={dueDateFilters}
        urlName="responseDateUnix"
      />
      <DateFilter
        title={"Posted Date"}
        filters={postedDateFilters}
        urlName="postingDateUnix"
      />
      <DateFilter
        title={"Last Updated Date"}
        filters={[
          {
            label: "Custom date",
            days: "past",
          },
        ]}
        urlName="lastUpdatedDateUnix"
      />
      <SearchFilter
        title={"Agencies"}
        urlName="agencyDetails"
        placeholder="Ex: U.S. Mission to Russia"
        items={agencies.sort()}
      />
      <SearchFilter
        title={"Applicant Types"}
        urlName="applicantTypes"
        placeholder="Ex: Small businesses"
        items={applicantTypes.sort()}
      />
      <SearchFilter
        title={"Funding Categories"}
        urlName="fundingActivityCategories"
        placeholder="Ex: Education"
        items={fundingCategories.sort()}
      />
      <CollapsibleFilter
        title={"Funding Instruments"}
        urlName="fundingInstruments"
        items={fundingInstruments}
      />
      <CollapsibleFilter
        title={"Opportunity Category"}
        urlName="opportunityCategory"
        items={opportunityCategory}
      />
    </div>
  );
}
